// extracted by mini-css-extract-plugin
export default {"container":"WordleGame_container__MyN8y","gameContainer":"WordleGame_gameContainer__cUwgN"};